// extracted by mini-css-extract-plugin
export default {"fixed":"q5dUs","back-button":"TjXeY","mobile-edit-button":"EYW0Z","mobile-bar":"bPS_W"};